function adjustButtons(element, dots) {

  // Get the buttons
  const prev = element.querySelectorAll('.flickity-prev-next-button.previous')[0];
  const next = element.querySelectorAll('.flickity-prev-next-button.next')[0];

  // Wrap the dots in a div
  if (!dots.parentNode.classList.contains('button-row')) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('button-row');
    dots.parentNode.insertBefore(wrapper, dots);
    wrapper.appendChild(dots);
  }

  // Select the new button row div
  const btnRow = element.querySelectorAll('.button-row')[0];

  // Move buttons to it
  btnRow.insertBefore(prev, btnRow.firstChild);
  btnRow.appendChild(next);
}

export function adjustCarouselBtns(element, galleryFlickity, navFlickity) {
  if (!navFlickity) {
    return;
  }

  const prevArrow = document.querySelectorAll('.arrow-left')[0];
  const nextArrow = document.querySelectorAll('.arrow-right')[0];

  if (prevArrow && nextArrow) {
    prevArrow.addEventListener('click', () => {
      galleryFlickity.previous();
      navFlickity.previous();
    });

    nextArrow.addEventListener('click', () => {
      galleryFlickity.next();
      navFlickity.next();
    });
  }

  const flktyDots = element.querySelectorAll('.flickity-page-dots');

  if (flktyDots.length) {
    adjustButtons(element, flktyDots[0]);
  }

  const navFlickityElement = navFlickity.$element.find('.flickity-slider');
  const singleCellWidth = 85;

  function handleScreenResize() {
    const navContentWidth = navFlickity.cells.length * singleCellWidth;

    if (navContentWidth < navFlickityElement.width()) {
      navFlickityElement.addClass('align-left');
    } else if (navContentWidth > navFlickityElement.width()) {
      navFlickityElement.removeClass('align-left');
    }
  }

  handleScreenResize();
  window.addEventListener('resize', handleScreenResize);
}
